import React from "react";
import "./About_Content.css";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const About_Content = () => {
  return (
    <section className="About_Content">
      <div className="container">
        {/* <Common_Title_2 titleText={"About Us"} /> */}

        <div className="content_div">
          <div className="row align-items-center about_row justify-content-center">
            <div className="col-md-6 col-10  mb-4 mb-lg-0">
              <div className="left_img_div">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/about_us/about.jpeg"
                  }
                  className="inner_img"
                  alt="About Nutricos"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="inner_div">
                <h2>Nutricos was built on a simple belief</h2>

                <div className="quote_box">
                  India deserves better everyday snacks.
                </div>

                <p>Too many products today fall into two extremes:</p>

                <ul className="points_list">
                  <li>Expensive “healthy” brands</li>
                  <li>Low-quality mass-produced snacks</li>
                </ul>

                <p>We're building something different.</p>

                <p>
                  Traditional Indian snacks and beverages that are tasty,
                  hygienic, affordable, and made for everyday life.
                </p>

                <p>
                  From school tiffins and office breaks to travel munching and
                  summer refreshments, Nutricos is designed for real India.
                </p>

                <div className="goal_box">
                  <span>OUR GOAL</span>
                  <h4>
                    Make everyday snacking smarter, tastier, and more
                    accessible.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Content;
